export default {
  form: {
    button: {
      apply: 'Apply',
      cancel: 'Cancel',
      close: 'Close',
      remove: 'Remove all filters'
    }
  },
  table: {
    column: {
      operationId: 'Operation Id',
      sku: 'SKU',
      acquirer: 'Recipient',
      operator: 'Operator',
      amount: 'Amount',
      date: 'Date',
      orderDate: 'Order date',
      status: 'Status',
      cost: 'Cost',
      creditType: 'Credit type',
      customerMsisdn: 'Customer phone number',
      merchant_code: 'Merchant Code',
      query_type: 'Query Type',
      session_type: 'Type'
    }
  },
  operation: {
    label: {
      amount: 'Amount',
      cost: 'Cost',
      externalTransactionId: 'External transaction Id',
      receiver: 'Receiver',
      recipient: 'Recipient',
      referenceId: 'Reference Id',
      operatorName: 'Operator name',
      errorCode: 'Error code',
      shortcode: 'Shortcode',
      phoneNumber: 'Phone number',
      duration: 'Duration',
      msisdn: 'Phone number'
    }
  }
};
